//@flow
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs from "dayjs";
import React, { useEffect } from 'react'
import ContentLoader from "../../components/general/contentLoader/contentLoader";
import LanguageSelect from "../../components/general/languageSelect/languageSelect";
import { muiDatePickersLocales } from "../../helpers/muiGridLocales";
import useUserAction from "../../hooks/user/useUserAction";
import './main.css';
import useUserData from "../../hooks/user/useUserData";
import 'dayjs/locale/el'
import UnauthenticatedRouter from "../../routers/unauthenticatedRouter";
import Content from "./content";

const Main = () => {
	const { getUserPermissions } = useUserAction()
	const { isLoggedIn, language, loading } = useUserData()
	dayjs.locale(language);
	
	useEffect(() => {
		if (isLoggedIn) {
			getUserPermissions()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getUserPermissions, isLoggedIn])
	
	if (!isLoggedIn) return (
		<LocalizationProvider
			dateAdapter={AdapterDayjs}
			localeText={muiDatePickersLocales(language)}
		>
			<Box
				sx={{
					height: '100vh',
					background: 'background.primary'
				}}
			>
				<Toolbar sx={{ background: 'background.primary' }}>
					<Box sx={{ flexGrow: 1 }}/>
					<LanguageSelect/>
				</Toolbar>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						height: '85vh'
					}}
				>
					<UnauthenticatedRouter/>
				</Box>
			</Box>
		</LocalizationProvider>
	)
	return (
		<LocalizationProvider
			dateAdapter={AdapterDayjs}
			localeText={muiDatePickersLocales(language)}
		>
			{!loading ? (
				<Content/>
			) : (
				<ContentLoader loading={loading} withBackDrop useCircularLoader/>
			)}
		</LocalizationProvider>
	)
}

export default Main